import React, { Component, Fragment, lazy } from "react"
import "./MakingPanel.scss"
import PropTypes from "prop-types"
import { PaletteItemTooltipContent } from '../Common/PaletteItemTooltipContent'
import i18n from '../../i18n'

import SceneViewer from "./Component/SceneViewer/SceneViewer"
import pad from "../Common/NumberPad"

const EditTemplate = lazy(() => import("./Component/EditTemplate/EditTemplate"))
const ProgressTab = lazy(() => import("./Component/ProgressTab/ProgressTab"))
const VMButton = lazy(() => import("../../Common/VMButton"))

class MakingPanel extends Component {
  state = {
    previewProgress: 0
  };

  timer
  componentWillReceiveProps(nextProps) {
    clearInterval(this.timer)
    if (Date.now() - nextProps.lastPreviewRequestedDate < 60 * 1000) {
      this.timer = setInterval(() => {
        this.forceUpdate()
        if (Date.now() - nextProps.lastPreviewRequestedDate >= 60 * 1000) clearInterval(this.timer)
      }, 1000)
    }
  }

  previewTextRender = () => {
    if (this.props.isWaitForPreview) {
      if (this.state.previewProgress < 100) {
        return (
          <Fragment>
            <p 
              style={{
                margin: "10px",
                width: "",
                whiteSpace: "nowrap"
              }}
              lang={this.props.value}
            >
              {" "}
              {i18n.t("timeline.button.text1")}...
          </p>
          </Fragment>
        );
      } else {
        return (
          <Fragment>
            <p
              style={{
                margin: "10px",
                width: "",
                whiteSpace: "nowrap"
              }}
              lang={this.props.value}
            >
              {" "}
              {i18n.t("timeline.button.text2")}...
            </p>
          </Fragment>
        );
      }
    } else {
      const { lastPreviewRequestedDate } = this.props
      return (
        <p
          lang={this.props.value}
          style={{
            margin: "10px",
            width: "",
            whiteSpace: "nowrap"
          }}
        >
          {
            !this.props.currentUser.admin && Date.now() - lastPreviewRequestedDate < 60 * 1000
            ?
              i18n.t("timeline.button.text3").replace('{SECOND}', 60 - Math.floor((Date.now() - lastPreviewRequestedDate) / 1000))
            :
            <>
              {i18n.t("timeline.button.text3-2")}{" "}
            </>
          }
          
        </p>
      );
    }
  };

  IsAvaliableFunctionExists = () => {
    const { availableFunc } = this.props
    let isAvaliableFunctionExists = false
    const funcKeys = Object.keys(availableFunc)
    for (let i = 0; i < funcKeys.length; i++) {
      if (availableFunc[funcKeys[i]]) {
        isAvaliableFunctionExists = true
        break
      }
    }
    return isAvaliableFunctionExists
  }

  previewRequest = async () => {
    const { currentUser, isNoPayment, isWaitForPreview, sendPreviewRequest,onAlertDialogOpen } = this.props

    if (!currentUser || isNoPayment || !this.IsAvaliableFunctionExists()){
      onAlertDialogOpen()
      return
    }
    if (isWaitForPreview) return;

    await sendPreviewRequest(v => {
      this.setState({ previewProgress: v });
    })
  };

  generateDuration = duration => {
    if (isNaN(duration)) return null
    let str = duration.toFixed(2).replace('.', ':')
    if (duration < 10) str = '0' + str
    return str
  }

  generateSceneName = name => {
    let str = name.substring(4, name.length)
    if (str.split('-')[0].length === 1) str = '0' + str

    return `# ${str}`
  }

  render() {
    const btnStyle = {
      fontSize: "14px",
      float: "left",
      lineHeight: "1",
      marginTop: "-3px",
      borderRadius: "8px",
    };

    let isAvaliableFunctionExists = this.IsAvaliableFunctionExists()
    let isPreviewDisabled = this.props.isNoPayment || !isAvaliableFunctionExists
    return (
      <div className="panel">
        <ProgressTab
          selectedIndex={this.props.index}
          maxSceneCount={this.props.maxSceneCount}
          progress={this.props.progress}
          selectAfterScene={this.props.selectAfterScene}
          selectBeforeScene={this.props.selectBeforeScene}
          handleChangedSliderValue={this.props.handleChangedSliderValue}
          sendSaveTemporarilyRequest={this.props.sendSaveTemporarilyRequest}
          value={this.props.lang}
          showUploadPercentage={this.props.showUploadPercentage}
          isDetectedEmptyFootage={this.props.isDetectedEmptyFootage}
          sendRenderRequest={this.props.sendRenderRequest}
          saveState={this.props.saveState}
          uploadPercenage={this.props.uploadPercenage}
        />
        <SceneViewer
          scene={this.props.scene}
          preview={this.props.preview}
          selectedLayer={this.props.selectedLayer}
          templateWidth={this.props.templateWidth}
          templateHeight={this.props.templateHeight}
          addFootageToMaterial={this.props.addFootageToMaterial}
          cropImage={this.props.cropImage}
          material={this.props.material}
          previewImageURL={this.props.previewImageURL}
          handleClickPreviewImage={this.props.handleClickPreviewImage}
          language={this.props.value}
          layerSelectEvent={this.props.layerSelectEvent}
          handleFocusTextArea={this.props.handleFocusTextArea}
          changeMenu={this.props.changeMenu}
          clickImage={this.props.clickImage}
          videoName={this.props.videoName}
          templateName={this.props.templateName}
        />
        <EditTemplate
          scene={this.props.scene}
          layerSelectEvent={this.props.layerSelectEvent}
          material={this.props.material}
          templateWidth={this.props.templateWidth}
          templateHeight={this.props.templateHeight}
          addTextToMaterial={this.props.addTextToMaterial}
          addFootageToMaterial={this.props.addFootageToMaterial}
          getFile={this.props.getFile}
          cropImage={this.props.cropImage}
          value={this.props.value}
          previewImageURL={this.props.previewImageURL}
          handleClickPreviewImage={this.props.handleClickPreviewImage}
          handleFocusTextArea={this.props.handleFocusTextArea}
          handleClickFontIcon={this.props.handleClickFontIcon}
          isAvaliableFontChangeFunc={this.props.availableFunc.FontChange}
          selectedMenu={this.props.selectedMenu}
          changeMenu={this.props.changeMenu}
          clickImage={this.props.clickImage}
        />
        <div className="description">
          <p className="index">{this.generateSceneName(this.props.scene ? this.props.scene.Name : '')}</p>
          {
            (this.props.currentUser) &&
            <VMButton
              value={this.props.value}
              isTooltip={true}
              toolTipPlacement="left"
              toolTipContent={<PaletteItemTooltipContent kind={isPreviewDisabled ? "preview_nopayment" : "preview"} />}
              style={{ ...btnStyle}}
              width={"134px"}
              height="30px"
              color={!this.props.currentUser || isPreviewDisabled ? "disabled" : "dark-gray-v2"}
              onClick={this.previewRequest}
            >
              <div
                style={{
                  position: "relative",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}>
                {this.previewTextRender()}
                {
                  (!this.props.currentUser || isPreviewDisabled) &&
                  <img className="lock-img" src="https://front.videomonster.com/images-u6yd72dy/web/makeVideo/palette-icon/crown_icon.svg" alt='' />
                }
              </div>
            </VMButton>
          }

          <div className="slideLengthPannel">
            {
              this.props.enableAdjustLength && 
              <>
                <img className="reset" src="https://front.videomonster.com/images-u6yd72dy/common/v2/reset-btn.svg" alt="reset-icon" onClick={this.props.handleClickLengthAdjustResetBtn}/>
                <img className="btn" src="https://front.videomonster.com/images-u6yd72dy/web/lengthAdjustMinusIcon.svg" alt="minus-icon" onClick={this.props.handleClickLengthAdjustMinusBtn} />
                {/* TODO :: 슬라이드 길이 시간 입력 */}
                <div>{this.props.scene && this.generateDuration(this.props.scene.duration * this.props.scene.stretch)}</div>
                <img className="btn" src="https://front.videomonster.com/images-u6yd72dy/web/lengthAdjustPlusIcon.svg" alt="plus-icon" onClick={this.props.handleClickLengthAdjustPlusBtn} />
              </>
            }
          </div>
        </div>
      </div>
    );
  }
}

MakingPanel.defaultProps = {
  index: -1,
  selectedLayer: -1
};
MakingPanel.propTypes = {
  material: PropTypes.object.isRequired,
  scene: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  selectedLayer: PropTypes.number,
  layerSelectEvent: PropTypes.func
};

export default MakingPanel
